import { useTranslation } from "next-i18next";

import { ProductBySlugNonNullable } from "@/common/contracts/pdp.contracts";
import { showModal } from "@/ui/Modal2";
import Rating from "@/ui/Rating";
import { Helper } from "@/ui/typography/Helper";

type ProductDetailsInfoSellerReviewsProps = {
  product: ProductBySlugNonNullable;
};

export const ProductDetailsInfoSellerReviews = ({
  product,
}: ProductDetailsInfoSellerReviewsProps) => {
  const { t } = useTranslation();

  const merchant = product.merchant;
  const merchantRating = merchant.rating ?? 0;
  const reviewsCount = merchant.reviewsCount;

  if (!merchantRating) {
    return null;
  }

  const handleReviewsClick = () => {
    showModal("merchant-reviews", {
      merchant,
    });
  };

  return (
    <div className="flex items-center space-x-2">
      <div className="flex items-center">
        <Rating value={merchantRating} className="size-5" />
      </div>
      <button onClick={handleReviewsClick}>
        <Helper className="text-brand-500 underline">
          {t(
            reviewsCount === 1
              ? "pdp:pdp-seller-block-reviews.one"
              : "pdp:pdp-seller-block-reviews.other",
            { 0: reviewsCount }
          )}
        </Helper>
      </button>
    </div>
  );
};
